const BaseView = require('./view').default;

module.exports = BaseView.extend({});
